import { Injectable } from '@angular/core';
import { Observable, from, BehaviorSubject, Subject } from 'rxjs';
import { SharedService } from '../sheared/sharedService.service';
import { map } from 'rxjs/operators';
import { AngularFireDatabase } from '@angular/fire/database';
import { authenticationService, Clients } from '../Authentication/authentication.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { NotificationService } from '../Notifications/notification.service';
import { FactoryService } from './factory.service';
import { AssureurService } from '../Assureur/assureur.service';
import { createReadStream } from 'fs';



export interface Quittance {
  isChecked?: boolean;
  $key?: string;
  icon?: string;
  type_police?: string;
  nomAssureur: string,
  NumClient: string,
  NomPrenom: string,
  NumPolice: string,
  NumRef: string,
  dateEffet: string,
  DateExpiration: string,
  Montant: string,
  duree: number,
  montant_paye: number,
  date_paiement: string,
  mode_paie: string,
  Notification: string,
  dateNotification: Date,
  solde: false
}
@Injectable({
  providedIn: 'root'
})
export class HistoriqueDetailService implements Resolve<Observable<any[]>> {

  private _quittances = new BehaviorSubject<any[]>([]); // quittance[]=any
  loading: HTMLIonLoadingElement
  private dataStore: { quittances: any[] } = { quittances: [] };
  readonly quittances = this._quittances.asObservable();
  private quittance:any
  private lstAss:any[]
  constructor(private sharedService: SharedService,
    private db: AngularFireDatabase,
    private loadingController: LoadingController,
    private fact:FactoryService,
    private assur:AssureurService,
    private auth:authenticationService) {

      this.assur.ListAssreurs.subscribe(
        res =>{
              this.lstAss=res
        }
      )
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   // var profil = this.authservice.profile
   this.loading = await this.loadingController.create({
    message: 'Chargement...',
    duration: 30000,
    spinner: 'bubbles',
    mode:"ios"
  });

  await this.loading.present();
  
   let id=route.paramMap.get('id') 
   this.quittance= this.fact.getData(id)
   
   //console.log(profil);
   
    await this.historiquePolices(this.auth.profile).then(
      (res) => {
        this.dataStore.quittances = res
        this._quittances.next(Object.assign({}, this.dataStore).quittances)
        this.loading.dismiss();
        return Object.assign({}, this.dataStore).quittances
      }
    )

    return this.quittances
  }


  async historiquePolices(profil: Clients) {
    var handelResult = [];
    const tree = this.db.database.ref()
    const ref2 = tree.child(`Quittances/`)
    	
    await ref2.orderByChild('idKey').equalTo(profil.uid)
      //.orderByChild('nomAssureur').equalTo(profil.nomAssureur)
      .on('child_added', snapshot => {
        const $key = snapshot.key; // clé hashée de quittance
        tree.child(`Quittances/${$key}`)
          .once('value', snap => {
            if (snap.val().NumPolice==this.quittance.police) {                          
              var datejr=this.sharedService.getDate()
              var ex=this.sharedService.ConvertDMYorYMD(snap.val().dateExpi,"y/m/d")             
             let lstPaie=[]   
               
              for (const key in snap.val().listPaie) {
                if (Object.prototype.hasOwnProperty.call(snap.val().listPaie, key)) {
                  const element = snap.val().listPaie[key];
                  if (element.solde) {
                    lstPaie.push({                      
                      datePayment: element.datePayment,
                      heure: element.heure,
                      lieu: element.lieu,
                      modePayement: element.modePayement,
                      montantPayement:(typeof(element.mtnLivraison*1)===typeof(2000))? element.montantPayement*1-2000:element.montantPayement,
                      mtnLivraison:  element.mtnLivraison,
                      refAsapPayement: element.refAsapPayement.substr(-6),
                      refMobilePayement: element.refMobilePayement
                    })
                  
                  }
       
                }
              }
             // console.log(lstPaie);
              
              handelResult.push({
                $key:$key,
                lstPaie:lstPaie,
                cumulpaie:lstPaie.reduce((acc,curr)=>(Number(acc)+ Number(curr.montantPayement)),0),
                NumPolice:snap.val().NumPolice + " [ " + this.lstAss.find(e => e.CodeAssu==snap.val().CodeAssur).NomAssu + " ]",
                origine:this.lstAss.find(e => e.CodeAssu==snap.val().CodeAssur).NomAssu,
                duree:this.sharedService.diffDays(datejr, ex)*1+1,
                date:this.sharedService.ConvertDMYorYMD(snap.val().date_paiement),
                etatdoc:snap.val().etatdoc,
                colors:this.Etatcolor(snap.val().etatdoc),
                NumRef:snap.val().NumRef,
                montant_paye:snap.val().montant_paye,
                dateEffet:snap.val().dateEffet,
                dateExpi:snap.val().dateExpi,
                typeContrat:snap.val().type,
                immat:snap.val().Immat,
                lieu:snap.val().lieu,
                heure:snap.val().heure
              }) 
            }
          
        })
      });


    return await handelResult//this.PrepareData(handelResult)

  }


private Etatcolor(doc:string): any{
  let colors={
    color:"",
    bacg:""
  } 
  if (doc==="encours") {
   colors={
      color:"#482020",
      bacg:"#ff9400"
    } 
  } else if(doc==="Prêt") {
    colors={
      color:"#ffffff",
      bacg:"#03899e"
    } 
  } else if (doc==="retire"){
    colors={
      color:"#ffffff",
      bacg:"#9e0384"
    } 
  }
return colors;
}

}
